export default class Recorder {
    constructor(core) {
        this.paused = true;
        this.mediaRecorder = null;
        this.core = core;
    }

    record() {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        this.analyser = this.audioCtx.createAnalyser();
        this.analyser.minDecibels = -90;
        this.analyser.maxDecibels = -10;
        this.analyser.smoothingTimeConstant = 0.85;

        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function (constraints) {
                const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                if (!getUserMedia) {
                    return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                }
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            }
        }

        if (navigator.mediaDevices.getUserMedia) {
            console.log('getUserMedia supported.');
            navigator.mediaDevices.getUserMedia({audio: true}).then((stream) => {
                const source = this.audioCtx.createMediaStreamSource(stream);
                source.connect(this.analyser);
                this.mediaRecorder = new MediaRecorder(stream, {mimeType: 'audio/webm'})
                const onDataAvailable = function(recordedChunks) {
                    if (recordedChunks.data.size > 0) {
                        this.core.surfer.create()
                        this.core.surfer.register(recordedChunks.data)
                    }
                }
                this.mediaRecorder.addEventListener('dataavailable', onDataAvailable.bind(this), false);
                const onStart = function() {
                    this.paused = false;
                    this.core.setView('OnRecord');
                }
                this.mediaRecorder.addEventListener('start', onStart.bind(this), false);
                this.mediaRecorder.start();
            });
        } else {
            console.log('getUserMedia not supported on your browser!');
        }
    }

    stop() {
        this.mediaRecorder.stop();
    }

    pause() {
        this.mediaRecorder.pause();
        this.paused = true;
    }

    resume() {
        this.mediaRecorder.resume();
        this.paused = false;
    }
}